import * as $checkoutConfig from '../../services/checkoutConfig'

let installed = false

const install = Vue => {
  if (installed) {
    return
  }

  Object.defineProperties(Vue.prototype, {
    $checkoutConfig: {
      get () {
        return $checkoutConfig
      }
    }
  })

  installed = true
}

export default { install }
